import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import esFlag from '../../assets/flags/spain_flag.png'
import caFlag from '../../assets/flags/catalonia_flag.png'
import glFlag from '../../assets/flags/galicia_flag.png'
import euFlag from '../../assets/flags/basque_country_flag.png'

import './FlagSelector.css'

const LANGS = [
  { value: 'es', label: 'Castellano', flag: esFlag },
  { value: 'ca', label: 'Català', flag: caFlag },
  { value: 'eu', label: 'Euskara', flag: euFlag },
  { value: 'gl', label: 'Galego', flag: glFlag },
]

const FlagSelector = () => {
  const { i18n, t } = useTranslation('shared')
  const [isOpen, setIsOpen] = useState(false)
  const selectorRef = useRef(null)

  const current =
    LANGS.find((l) => l.value === i18n.resolvedLanguage) || LANGS[0]

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
    setIsOpen(false)
  }

  const handleClickOutside = (event) => {
    if (selectorRef.current && !selectorRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const otherLangs = LANGS.filter((lang) => lang.value !== current.value)

  return (
    <div
      className={`flag-selector__container ${isOpen ? 'flag-selector__container--open' : ''}`}
      ref={selectorRef}
    >
      <div
        className="flag-selector__current"
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        tabIndex={0}
        aria-label={t('changeLanguage')}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            setIsOpen(!isOpen)
          }
        }}
      >
        <img
          src={current.flag}
          alt={current.label}
          className="flag-selector__img"
        />
      </div>

      <div className="flag-selector__dropdown">
        {otherLangs.map((lang) => (
          <img
            key={lang.value}
            src={lang.flag}
            alt={lang.label}
            className="flag-selector__option-flag"
            onClick={() => changeLanguage(lang.value)}
            title={lang.label}
          />
        ))}
      </div>
    </div>
  )
}

export default FlagSelector
